import React from "react";
import AugmentedMessage from "./AugmentedMessage";
import S from "./Message.styled";
import MessageFile from "./MessageFile";
const PlainMessage = ({ message, status, editableMessageId, setEditableMessageId, }) => {
    return (React.createElement(S.Gutter, { size: "large" },
        React.createElement(AugmentedMessage, { status: status, message: message, editableMessageId: editableMessageId, setEditableMessageId: setEditableMessageId }),
        message.fileToken ? React.createElement(MessageFile, { token: message.fileToken }) : null));
};
export default PlainMessage;
//# sourceMappingURL=PlainMessage.js.map